import { createContext } from "react";

const BI_AUT002Context = createContext();

export {BI_AUT002Context}